import React from 'react'
import customer1 from '../../../assets/customer1.svg'
import customer2 from '../../../assets/customer2.svg'
import customer3 from '../../../assets/customer3.svg'
import ellipse3 from '../../../assets/Ellipse3.svg'
import EllipsePattern from '../../../assets/EllipsePattern.svg'
import Ellipse22 from '../../../assets/Ellipse22.svg'
import Container from './styles'

const customers = [
  { name: 'Wale Oluwole', img: customer1 , content:"Relatively easy to arrange delivery, I recommend them over any delivery platform out there"},
  { name: 'Sade Alade', img: customer2, content:"A very straight forward process, received confirmation by E-mail within minutes." },
  { name: 'Obinna Abulu', img: customer3, content:"Very easy and straightforward system excellent. The tracking comes in handy to check the actual state of my order" },
]
const SectionFour = () => {
  return (
    <Container>
      <img
        src={EllipsePattern}
        alt="EllipsePattern"
        className="ellipsePattern--img"
      />
      <div className="ellipse--container">
        <img src={ellipse3} alt="Ellipse" />
        <h3>See what our customers are saying</h3>
      </div>
      <div className="grid--container">
        {customers.map((item, i) => (
          <div className="customer--container" key={i}>
            <div className="row">
              <img src={item.img} alt="customer" />
              <h3>{item.name}</h3>
            </div>
            <p>
              {item.content}
            </p>
          </div>
        ))}
      </div>
      <img
        src={Ellipse22}
        alt="EllipsePattern"
        className="ellipsePattern--img__2"
      />
    </Container>
  )
}

export default SectionFour
